module.exports = __webpack_public_path__ + "media/images/promotions/cards/fate-3-6e8fa07dc5b5dfd7f8c1c5a2534067f3.svg";